import { toast } from "react-toastify";

const errorHandler = (error, setAuthData) => {
    if(error?.response?.status === 401 && window.location.pathname !== "/auth/login") {
        localStorage.clear();
        setAuthData({});
        window.location.href = "/auth/login";
    }
    return Promise.reject(error);
};
  
const responseHandler = (response, setAuthData) => {
    if((response?.data?.response?.code === -2 || response?.status === 401) && window.location.pathname !== "/auth/login") {
        toast.error(response?.data?.response?.msg);
        setTimeout(()=>{
            localStorage.clear();
            setAuthData({});
            window.location.href = "/auth/login";
        }, 1000)
        return;
    }
    
    return response;
};
  
export default function setupAxios(axios, authData, setAuthData){
    axios.interceptors.request.use(
        (config) => {

            const tokenObj = {
                practice_id: authData?.practice?.id,
                new_chat: 1
            };
            
            if(authData?.is_provider){
                tokenObj.token = authData.auth;
            }
            else{
                tokenObj.na_auth = authData?.auth
            }
            
            config.params = {...tokenObj, tz: new Date().getTimezoneOffset(), ...config.params,}

            const date = new Date();
            config.params = {tz:date.getTimezoneOffset(),...config.params,}
            return config;
        },
        (error) => errorHandler(error)
    );
  
    axios.interceptors.response.use(
      (response) => responseHandler(response, setAuthData),
      (error) => errorHandler(error, setAuthData)
    );
}  